'use client';

import { createContext } from 'react';

const AbsoluteContext = createContext<boolean>(false);

export default AbsoluteContext;
